import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Award, Target, Users } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../components/ui/carousel';

const About = () => {
  const officeImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_ca-piyush-gupta/artifacts/n0hvp9fw_CHARTERED%20ACCOUNTANT%20OFFICE.jpeg',
      caption: 'Our Professional Office Space'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_ca-piyush-gupta/artifacts/2p1qfaps_CA%20OFFICE%20WORK%20STATION.jpeg',
      caption: 'Modern Workstations & Team Area'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_2406485c-f1d1-45bc-9d99-ebd32db2d247/artifacts/6a3ri34d_wwwww.png',
      caption: 'CA Piyush Gupta'
    }
  ];

  const values = [
    {
      icon: <CheckCircle size={32} />,
      title: 'Accuracy',
      description: 'Precise financial reporting and error-free compliance'
    },
    {
      icon: <Target size={32} />,
      title: 'Strategic Approach',
      description: 'Proactive tax planning and financial structuring'
    },
    {
      icon: <Users size={32} />,
      title: 'Client-Centric',
      description: 'Personalized attention and transparent communication'
    },
    {
      icon: <Award size={32} />,
      title: 'Professional Excellence',
      description: 'Qualified expertise with proven track record'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <h1 className="page-hero-title">About Us</h1>
          <p className="page-hero-subtitle">
            Your Trusted Partner for Financial Success
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-main">
        <div className="container">
          <div className="about-main-content">
            <div className="about-main-text">
              <h2 className="about-heading">CA Piyush Gupta</h2>
              <h3 className="about-subheading">Gupta Piyush & Company</h3>
              
              <p className="about-paragraph">
                <strong>Gupta Piyush & Company</strong> is a Chartered Accountancy firm committed 
                to delivering high-quality financial, taxation, and compliance services to businesses 
                and individuals across Muzaffarnagar and beyond.
              </p>
              
              <p className="about-paragraph">
                With a client-centric approach, we provide comprehensive solutions that help our 
                clients navigate the complex landscape of taxation, compliance, and financial management 
                with confidence and clarity.
              </p>

              <div className="about-features">
                <div className="about-feature">
                  <CheckCircle className="feature-check" />
                  <span>Accurate financial reporting</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-check" />
                  <span>Strategic tax structuring</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-check" />
                  <span>Risk-minimized compliance management</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-check" />
                  <span>Transparent communication</span>
                </div>
              </div>
            </div>

            <div className="about-main-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_2406485c-f1d1-45bc-9d99-ebd32db2d247/artifacts/6a3ri34d_wwwww.png" 
                alt="CA Piyush Gupta" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2 className="mission-title">Our Mission</h2>
            <p className="mission-text">
              To help businesses grow with financial clarity and regulatory confidence. We strive 
              to be more than just service providers – we aim to be trusted advisors who contribute 
              to our clients' long-term success.
            </p>
          </div>
        </div>
      </section>

      {/* Office Gallery Section */}
      <section className="office-gallery-section">
        <div className="container">
          <h2 className="section-title-center">Our Office</h2>
          <p className="section-subtitle">
            Visit us at our professional office space in Muzaffarnagar
          </p>
          
          <div className="office-carousel-wrapper">
            <Carousel className="office-carousel">
              <CarouselContent>
                {officeImages.map((image, index) => (
                  <CarouselItem key={index}>
                    <div className="office-image-container">
                      <img 
                        src={image.url} 
                        alt={image.caption}
                        className="office-image"
                      />
                      <div className="office-image-caption">
                        {image.caption}
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="carousel-button-prev" />
              <CarouselNext className="carousel-button-next" />
            </Carousel>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title-center">Our Core Values</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-card-icon">{value.icon}</div>
                <h3 className="value-card-title">{value.title}</h3>
                <p className="value-card-text">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="about-cta-content">
            <h2 className="about-cta-title">Let's Work Together</h2>
            <p className="about-cta-text">
              Partner with us for reliable, professional, and result-oriented financial services
            </p>
            <Link to="/contact" className="btn btn-primary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
